export enum Status {
  complete = 'complete',
  signing = 'signing',
  pending = 'pending',
  error = 'error'
}
export type State = `req_${Status}_${string}` | `tx_${Status}`

export type ParsedState =
  | { type: 'req'; status: Status; id: string }
  | { type: 'tx'; status: Status }

/**
 * Parses state machine state string into structured object.
 * @param state - State string (e.g., "req_signing_123" or "tx_pending")
 * @returns Parsed state with type, status, and optional id
 * @internal
 */
export const parseState = (state: State) => {
  const [type, status, id] = state.split('_')
  // oxlint-disable-next-line typescript/consistent-type-assertions
  return { type, status, id } as ParsedState
}
